import { render } from "./PaymentProcessingPage.vue?vue&type=template&id=40b345e5&scoped=true"
import script from "./PaymentProcessingPage.vue?vue&type=script&lang=js"
export * from "./PaymentProcessingPage.vue?vue&type=script&lang=js"

import "./PaymentProcessingPage.vue?vue&type=style&index=0&id=40b345e5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40b345e5"]])

export default __exports__